import React from 'react';
import * as Styled from './styled';

export const Trigger: React.FC = (props) => {
    const { children, ...rest } = props;
    return <Styled.CollapseTrigger {...rest}>{children}</Styled.CollapseTrigger>;
};

Trigger.displayName = 'Collapse.Trigger';
